import { render, staticRenderFns } from "./AlfaQuotaPayment.vue?vue&type=template&id=69f5b5a4&scoped=true&"
import script from "./AlfaQuotaPayment.vue?vue&type=script&lang=js&"
export * from "./AlfaQuotaPayment.vue?vue&type=script&lang=js&"
import style0 from "./AlfaQuotaPayment.vue?vue&type=style&index=0&id=69f5b5a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f5b5a4",
  null
  
)

/* custom blocks */
import block0 from "./AlfaQuotaPayment.vue?vue&type=custom&index=0&blockType=i18n&lang=yml&locale=ru"
if (typeof block0 === 'function') block0(component)
import block1 from "./AlfaQuotaPayment.vue?vue&type=custom&index=1&blockType=i18n&lang=yml&locale=en"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VCheckbox,VDialog})
